import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as Theme from "../../../app/Theme";

import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import RCCustomIndicatorForm from "../Forms/RCCustomIndicatorForm";

import TSlideDrawer from "../../common/TSlideDrawer";

import {
    callSuccessFn,
    cloneObj,
} from "../../GB/GBUtil";

class RCCustomIndicatorDrawer extends Component {

    static propTypes = {

        onDrawerChange           : PropTypes.func,

        indicatorObjList         : PropTypes.arrayOf(PropTypes.object),
        onIndicatorObjListChange : PropTypes.func,

        selectedIndCurrID         : PropTypes.number,
        onSelectedIndicatorChange : PropTypes.func,

    };

    static defaultProps = {

        onDrawerChange           : () => console.log("onDrawerChange"),

        indicatorObjList         : {},
        onIndicatorObjListChange : () => console.log("onIndicatorObjListChange"),

        selectedIndCurrID         : 1,
        onSelectedIndicatorChange : () => console.log("onIndicatorObjListChange"),

    };

    state = {

        /* D = Drawer */
        indicatorObjList_D  : cloneObj(this.props.indicatorObjList),
        selectedIndCurrID_D : this.props.selectedIndCurrID,

        applyBtnEnabled     : false,

    };

    onSlideDrawerSaveBtnClick = () => {

        try {

            /* state */

            const state = this.state;

            /* props */

            const props = this.props;

            props.onIndicatorObjListChange(state.indicatorObjList_D, () => {

                props.onSelectedIndicatorChange(state.selectedIndCurrID_D, () => {

                    this.setState({

                        applyBtnEnabled : false,

                    }, () => {

                        props.onDrawerChange();

                    });

                });

            });

        }
        catch (exception) {

            this.setState({

                applyBtnEnabled : false,

            }, () => alert(exception.name + ': ' + exception.message));

        }

    };

    onIndicatorObjListChange_D = (indicatorObjList, successFn) => {

        try {

            this.setState({

                indicatorObjList_D : indicatorObjList,
                applyBtnEnabled    : true,

            }, () => callSuccessFn(successFn));

        }
        catch (exception) {

            this.setState({

                applyBtnEnabled : false,

            }, () => alert(exception.name + ': ' + exception.message));

        }

    };

    onSelectedIndicatorChange_D = (selectedIndCurrID, successFn) => {

        try {

            this.setState({

                selectedIndCurrID_D : selectedIndCurrID,
                applyBtnEnabled     : true,

            }, () => callSuccessFn(successFn));

        }
        catch (exception) {

            this.setState({

                applyBtnEnabled : false,

            }, () => alert(exception.name + ': ' + exception.message));

        }

    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {

        /* props */

        const props = this.props;
        const onDrawerChange = props.onDrawerChange;

        /* state */

        const state = this.state;
        const applyBtnEnabled = state.applyBtnEnabled;
        const indicatorObjList_D = state.indicatorObjList_D;
        const selectedIndCurrID_D = state.selectedIndCurrID_D;

        const formComp =
            <RCCustomIndicatorForm
                indicatorObjList_D          = {indicatorObjList_D}
                onIndicatorObjListChange_D  = {this.onIndicatorObjListChange_D}

                selectedIndCurrID_D         = {selectedIndCurrID_D}
                onSelectedIndicatorChange_D = {this.onSelectedIndicatorChange_D}
            />;

        const slideDrawer =
            <TSlideDrawer
                anchor           = {"right"}
                content          = {formComp}
                headerTitleStyle = {{
                    color : Theme.RC_PrimaryColor,
                }}
                saveButton       = {true}
                saveBtnCaption   = {RS(SC.GB_stApply)}
                saveBtnEnabled   = {applyBtnEnabled}
                title            = {RS(SC.GB_stMngCustomIndicators)}
                onClose          = {onDrawerChange}
                onSave           = {this.onSlideDrawerSaveBtnClick}
            />;


        return slideDrawer;

    }

}

export default RCCustomIndicatorDrawer;
